import './table.scss';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const List = () => {
  const [rows, setRows] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchLatestOrders = async () => {
      try {
        const token = localStorage.getItem('accessToken');

        const res = await fetch(
          `${apiUrl}/orders?page=1&limit=5&sort=-createdAt`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        // assuming your API structure like:
        // { data: [], pagination: {} }
        const orders = Array.isArray(data?.data) ? data.data : [];

        setRows(orders);
      } catch (err) {
        console.error(err);
        setRows([]);
      }
    };

    fetchLatestOrders();
  }, [apiUrl]);

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString();
  };

  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>Order ID</TableCell>
            <TableCell>Amount (RM)</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row._id}>
              <TableCell>{row._id}</TableCell>

              <TableCell>
                {Number(row.grandTotal || 0).toFixed(2)}
              </TableCell>

              <TableCell>
                <span className={`status ${row.status}`}>
                  {row.status?.toUpperCase()}
                </span>
              </TableCell>

              <TableCell>
                {formatDate(row.createdAt)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default List;